/** @format */

import React, { useState } from 'react'
import styled from 'styled-components'
import { _$ } from '@king-design/react'
import { ServiceOverviewSearchProps } from '../../components/typescript'
import { ExpandContainer, TableSearch, parseTableSearchParams } from 'src/components'
import { TraceAnalysisSearchProps, FilterMtchProps } from '../typescript'
import { initSpanAttributeFilters, initTraceAnalysisSearch } from '../constant'
import SpanSearch from './SpanSearch'
import TraceSearch from './TraceSearch'
import TraceTable from './TraceTable'
import { useLocation, useHistory } from 'react-router-dom'
import { replaceSearchParams } from 'src/utils'

interface TraceContainerProps {
  className?: string
  headerSearch: ServiceOverviewSearchProps
  serviceName?: string
  region?: string
}

/** 解析当前 URL search，供详情请求参数使用 */
function useQuery() {
  return new URLSearchParams(useLocation().search)
}
const TraceContainer: React.FC<TraceContainerProps> = ({
  className,
  headerSearch,
  serviceName,
  region
}) => {
  const history = useHistory()
  const location = useLocation()
  const query = useQuery()
  const serachExpanded = query.get('serachExpanded')
  const [expanded, setExpanded] = useState(serachExpanded === 'true')
  const [traceSearch, setTraceSearch] = useState<TraceAnalysisSearchProps>(() => {
    const urlParmas = parseTableSearchParams(location.search, 'traceSearch') || {}
    return {
      ...initTraceAnalysisSearch,
      // 从服务详情跳入时预填服务名
      Filters: serviceName
        ? [
            {
              Key: 'service_name',
              Op: 'in',
              Values: [serviceName]
            }
          ]
        : initTraceAnalysisSearch.Filters,
      ...urlParmas
    }
  })
  const [spanSearchSearch, setSpanSearchSearch] =
    useState<FilterMtchProps[]>(initSpanAttributeFilters)

  return (
    <div className={className}>
      <TableSearch params={traceSearch} noStyle paramsKey="traceSearch">
        <ExpandContainer
          expandText={_$('展开筛选')}
          collapseText={_$('收起筛选')}
          expanded={expanded}
          onExpandedChange={nextExpanded => {
            replaceSearchParams(history, location, { serachExpanded: nextExpanded })
            setExpanded(nextExpanded)
          }}
        >
          <div className="trace-analysis-sidebar" aria-label={_$('列表筛选')}>
            <TraceSearch
              startTime={headerSearch?.time[0]}
              endTime={headerSearch?.time[1]}
              value={traceSearch.Filters}
              serviceName={serviceName}
              onChange={filters => {
                setTraceSearch({ ...traceSearch, Page: 1, Filters: filters })
              }}
            />
            <SpanSearch
              startTime={headerSearch?.time[0]}
              endTime={headerSearch?.time[1]}
              value={spanSearchSearch}
              onChange={setSpanSearchSearch}
            />
          </div>
        </ExpandContainer>
      </TableSearch>
      <TraceTable
        headerSearch={headerSearch}
        serviceName={serviceName}
        traceSearch={traceSearch}
        setTraceSearch={setTraceSearch}
        spanSearchSearch={spanSearchSearch}
        region={region}
      />
    </div>
  )
}

export default styled(TraceContainer)`
  border-top: 1px solid #e0e0e0;
  margin-top: 16px;

  .trace-analysis-sidebar {
    flex-shrink: 0;
    margin-bottom: 16px;
    overflow: hidden;

    > *:first-child {
      margin-top: 0 !important;
    }
  }
`
